import React from 'react';
import PropTypes from 'prop-types';

export const UnclarifiedPayee = ({ width, height, ...props }) => (
  <svg
    data-icon='unclarified-payee'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11.25 21.975A9.938 9.938 0 0 1 7.612 21a9.981 9.981 0 0 1-2.937-2.163 9.961 9.961 0 0 1-1.962-3.1A9.877 9.877 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12v.475a8.23 8.23 0 0 0-.988-.537c-.375-.176-.72-.321-1.037-.438-.133-2.1-.963-3.875-2.488-5.325C15.963 4.725 14.134 4 12 4c-.933 0-1.813.15-2.637.45-.825.3-1.58.717-2.263 1.25l6.125 6.125c-.317.133-.62.288-.912.463-.292.175-.58.362-.863.562L5.7 7.1a8.217 8.217 0 0 0-1.25 2.263C4.15 10.188 4 11.067 4 12c0 1.65.446 3.13 1.338 4.438.891 1.308 2.045 2.27 3.462 2.887.3.467.675.942 1.125 1.425.45.483.892.892 1.325 1.225ZM17 20c.983 0 1.896-.225 2.738-.675A5.387 5.387 0 0 0 21.75 17.5a5.387 5.387 0 0 0-2.012-1.825A5.716 5.716 0 0 0 17 15c-.983 0-1.896.225-2.738.675A5.387 5.387 0 0 0 12.25 17.5c.5.767 1.17 1.375 2.012 1.825.842.45 1.755.675 2.738.675Zm0 2c-1.6 0-3.03-.42-4.287-1.262-1.259-.842-2.163-1.921-2.713-3.238.55-1.317 1.454-2.396 2.713-3.238C13.97 13.421 15.4 13 17 13s3.03.42 4.288 1.262c1.258.842 2.162 1.921 2.712 3.238-.55 1.317-1.454 2.396-2.712 3.238C20.029 21.579 18.6 22 17 22Zm0-3c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0 1 15.5 17.5c0-.417.146-.77.438-1.063A1.446 1.446 0 0 1 17 16c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 17 19Z'
    />
  </svg>
);

UnclarifiedPayee.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

UnclarifiedPayee.defaultProps = {
  width: 24,
  height: 24,
};
